<template>
  <div class="info_Hot_container">
    <div class="header">
      <div class="bodyTitle">
        <img alt src="../assets/Starting/img-phb/newstitle.png" />
        <div class="pageTitle">{{ pageTitle }}</div>
        <img
          class="img_monitor"
          alt
          src="../assets/Starting/img-phb/newstitle.png"
        />
      </div>
      <div class="sel">
        <el-select
          placeholder="请选择订阅分组"
          @change="gend(value)"
          v-model="value"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            style="color: #04def7;color:0.94vw;"
          ></el-option>
        </el-select>
      </div>
      <div class="tab0">
        <div
          :class="checkId == item.id ? 'active' : ''"
          :key="item.id"
          @click="handleClick(item.id)"
          class="tab"
          v-for="item in checks"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="main" v-show="wx_ready && wb_ready" v-if="checkId == '1'">
      <div class="main_list">
        <ul class="list">
          <li class="list_title">
            <ul>
              <li
                class="wx_list_title"
                v-for="(item, index) in wx_title"
                :key="index"
              >
                {{ item.wx_name }}
              </li>
            </ul>
          </li>
          <template v-show="wx_list">
            <li
                :class="[
              active_index == index ? 'active' : '',
              list_show >= index ? 'list_show' : '',
            ]"
                class="wx_list_item"
                v-for="(item, index) in wx_list"
                :key="index"
            >
              <div class="counts1" v-if="item.sourcename!=='合肥消防在线'">{{ index }}</div>
              <div class="counts1" v-else>{{ wxIndex }}</div>
              <div class="counts2">
                {{ item.sourcename}}
              </div>
              <div class="counts3">
                <img
                    alt
                    v-if="item.rankingChange === 0"
                    src="../assets/Starting/img-phb/up.png"
                />
                <img alt v-else src="../assets/Starting/img-phb/down.png" />
              </div>
              <div class="counts4">{{ item.s_num }}</div>
              <div class="counts5">{{ item.s_read }}</div>
              <div class="counts6">{{ item.s_good }}</div>
              <div class="counts7">{{ item.wci }}</div>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <div class="main" v-show="wx_ready && wb_ready" v-if="checkId == '2'">
      <div class="main_list">
        <ul class="list">
          <li class="list_title">
            <ul>
              <li
                class="wb_list_title"
                v-for="(item, index) in wb_title"
                :key="index"
              >
                {{ item.wb_name }}
              </li>
            </ul>
          </li>
          <li
            :class="[
              active_index == index ? 'active' : '',
              list_show >= index ? 'list_show' : '',
            ]"
            :key="index"
            class="wb_list_item"
            v-for="(item, index) in wb_list"
          >
            <div class="counts1" v-if="item.sourceName !=='合肥消防'">{{ index }}</div>
            <div class="counts1" v-else>{{ wbIndex }}</div>
            <div class="counts2">
              {{ item.sourceName}}
            </div>
            <div class="counts3">
              <img
                alt
                v-if="item.rankingChange == 0"
                src="../assets/Starting/img-phb/up.png"
              />
              <img alt v-else src="../assets/Starting/img-phb/down.png" />
            </div>
            <div class="counts4">{{ item.sendArticleCount }}</div>
            <div class="counts5">{{ item.goodCount }}</div>
            <div class="counts6">{{ item.commentCount }}</div>
            <div class="counts6">{{ item.forwardCount }}</div>
            <div class="counts7">{{ item.bci }}</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { timeList, wxList, wbList } from "../api/article.js";

export default {
  data() {
    return {
      pageTitle: "资讯排行榜",
      options: [],
      value: "",
      wbIndex: 0,
      wxIndex: 0,
      wx_title: [
        { wx_name: "排行" },
        { wx_name: "微信公众号" },
        { wx_name: "排名变化" },
        { wx_name: "本周发布量" },
        { wx_name: "本周阅读量" },
        { wx_name: "本周点赞量" },
        { wx_name: "WCI指数" },
      ],
      wb_title: [
        { wb_name: "排名" },
        { wb_name: "微博账号" },
        { wb_name: "排名变化" },
        { wb_name: "本周发布量" },
        { wb_name: "本周点赞量" },
        { wb_name: "本周评论量" },
        { wb_name: "本周转发量" },
        { wb_name: "BCI指数" },
      ],
      wx_list: [],
      wb_list: [],
      wx_ready: true,
      wb_ready: true,
      active_index: -1,
      list_show: -1,
      list_animation: undefined,
      list_fade_in: undefined,
      list_fade_out: undefined,

      groupId: "", //微博
      checks: [
        { name: "微信公众号排行", id: "1" },
        { name: "微博热搜排行", id: "2" },
      ],
      checkId: "0",
    };
  },
  created() {
    if (this.$route.query.innerTitle) {
      this.pageTitle = this.$route.query.innerTitle;
    }
    this.page_init();
  },
  mounted() {
    this.timelond();
  },
  destroyed() {
    clearInterval(this.list_animation);
  },
  methods: {
    gend(id) {
      this.groupId = id
      this.options.filter(val=>{
        if(val.id===id){
          this.getGroupList(val);
          this.wxlond(val);
        }
      })
    },
    page_init() {
      let t = setInterval(() => {
        if (!this.wx_ready || !this.wb_ready) return;
        clearInterval(t);
        this.checkId = "1";
        this.fade_in();
      }, 200);
    },
    timelond() {
      timeList({}).then((res) => {
        this.options = res.data.data;
        this.groupId = this.options[0].id
        this.getGroupList(this.options[0]);
        this.wxlond(this.options[0]);
      });
    },
    //微博 接口数据
    getGroupList() {
      wbList({
        parentId: sessionStorage.getItem('supId')*1,
        // parentId:26,
        timeRange: 1,
        groupId: this.groupId,
      }).then((res) => {
        this.wb_list = res.data.data
        let hefei = {}
        this.wb_list.filter((val,index)=>{
          if(val.sourceName==='合肥消防'){
            hefei = val
            if(index>10){
              this.wbIndex = 10
            }else {
              this.wbIndex = index+1
            }

          }
        })
        this.wb_list.splice(0,0,hefei)
        this.wb_list.splice(10)
        // this.wb_list.splice(0,0,hefei)

        // this.wb_list.splice(0,0,{
        //   "sourceName": "合肥消防",
        //   "fansCount": null,
        //   "sendArticleCount": 111,
        //   "originalSendArticleCount": 111,
        //   "goodCount": 111,
        //   "forwardCount": 111,
        //   "commentCount": 111,
        //   "readCount": null,
        //   "originalForwardCount": 111,
        //   "originalCommentCount": 111,
        //   "bci": 111.111,
        //   "isOriginal": null,
        //   "localHead": null,
        //   "articleReadCount": null,
        //   "ranking": 10,
        //   "rankingChange": -11
        // })
        console.log(res.data.data,'微博')
      });
    },
    //微信 接口数据
    wxlond(val) {
      wxList({
        range:'1m',
        groupName: val.name,
        timeRange: 1,
      }).then((res) => {
        this.wx_list = res.data.data.result;
        let hefei = {}
        this.wx_list.filter((val,index)=>{
          if(val.sourcename==='合肥消防在线'){
            hefei = val
            if(index>10){
              this.wxIndex = index
            }

          }
        })
        this.wx_list.splice(0,0,hefei)
        this.wx_list.splice(10)
        console.log( res.data.data,' res.data.data')
      });
    },

    fade_in() {
      const _len =
        this.checkId === "1" ? this.wx_list.length : this.wb_list.length;
      this.list_show = -1;
      this.list_fade_in = setInterval(() => {
        if (this.list_show > _len - 1) {
          clearInterval(this.list_fade_in);
          this.set_animation_list();
        } else {
          this.list_show++;
        }
      }, 400);
    },
    set_animation_list() {
      const _len =
        this.checkId === "1" ? this.wx_list.length : this.wb_list.length;
      this.active_index = 0;
      this.list_animation = setInterval(() => {
        if (this.active_index < _len - 1) {
          this.active_index++;
        } else {
          clearInterval(this.list_animation);
          this.fade_out();
        }
      }, 3000);
    },
    fade_out() {
      this.list_show = -1;
      this.active_index = -1;
      this.checkId === "1" ? "2" : "1";
      this.list_fade_out = setTimeout(() => {
        clearTimeout(this.list_fade_out);
        this.fade_in();
      }, 400);
    },
    groupChange() {
      clearInterval(this.list_fade_in);
      clearInterval(this.list_animation);
      clearTimeout(this.list_fade_out);
      this.wx_list = []; // 考虑删除
      this.wb_list = []; // 考虑删除
      this.wx_ready = false;
      this.wb_ready = false;
      this.active_index = -1;
      this.list_show = -1;
      this.getWXRange();
      this.getWBRange();
      let t = setInterval(() => {
        if (!this.wx_ready || !this.wb_ready) return;
        clearInterval(t);
        setTimeout(() => this.fade_in(), 400);
      }, 200);
    },
    handleClick(index) {
      clearInterval(this.list_fade_in);
      clearInterval(this.list_animation);
      clearTimeout(this.list_fade_out);
      this.list_show = -1;
      this.active_index = -1;
      setTimeout(() => {
        this.checkId = index;
        this.fade_in();
      }, 400);
    },
  },
};
</script>

<style lang="scss">
.header {
  .sel {
    .el-select {
      width: 100%;
      height: 100%;
    }
    .el-input--suffix .el-input__inner {
      background: transparent;
      color: #04def7;
      font-size: 0.85vw;
      height: 100%;
    }
    .el-input {
      height: 100%;
    }
    .el-input__suffix {
      top: 5px;
    }
  }
}
</style>

<style scoped lang="scss">
.info_Hot_container {
  background-image: url("../assets/Starting/img-phb/bg_infoHot.jpg");
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  position: relative;
  .header {
    margin: 0 2.5%;
    display: flex;
    align-items: center;
    height: 12.2vh;
    user-select: none;
    .bodyTitle {
      height: 7.4vh;
      font-size: 1.37vw;
      font-weight: bold;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      img {
        width: 6vw;
      }
      .img_monitor {
        transform: rotate(180deg);
      }
      .pageTitle {
        margin: 0 0.5em;
        white-space: nowrap;
      }
    }
    .sel {
      margin-left: 2.5vw;
      width: 12.9%;
      height: 3.5vh;
    }
    .tab0 {
      display: flex;
      position: absolute;
      right: 2.5%;
      .tab {
        height: 3.15vh;
        text-align: center;
        color: #fff;
        font-size: 1vw;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        cursor: pointer;
        margin: 0 0.5vw;
      }
      .active {
        border-bottom: 2px solid #f4b613;
        color: #f4b613;
      }
    }
  }
  .main {
    width: 100%;
    height: calc(100% - 12.2vh - 0.1%);
    padding: 3vh 2.7% 6.4vh 2.3%;
    .main_list {
      width: calc(100% - 5%);
      height: calc(100% - 11.6vh);
      .list {
        font-size: 0.97vw;
        color: white;
        .list_title {
          width: 100%;
          height: 2.3vh;
          line-height: 2.3vh;
          margin-bottom: 1.7vh;
          .wx_list_title,
          .wb_list_title {
            display: inline-block;
            text-align: center;
            &:nth-child(1) {
              width: 5%;
            }
            &:nth-child(2) {
              width: 30%;
              text-align: left;
            }
            &:nth-child(3) {
              width: 5%;
            }
          }
          .wx_list_title {
            &:nth-child(4),
            &:nth-child(5),
            &:nth-child(6),
            &:nth-child(7) {
              width: 15%;
            }
          }
          .wb_list_title {
            &:nth-child(4),
            &:nth-child(5),
            &:nth-child(6),
            &:nth-child(7),
            &:nth-child(8) {
              width: 12%;
            }
          }
        }
        .wx_list_item,
        .wb_list_item {
          width: 100%;
          height: 6.3vh;
          line-height: 6.3vh;
          margin-bottom: 1.5vh;
          display: flex;
          border-radius: 8px;
          background-image: -webkit-linear-gradient(
            left,
            rgba(0, 200, 255, 0.4),
            rgba(145, 165, 185, 0.4)
          );
          position: relative;
          transition: all 0.4s;
          transform: translate(80px, 80px);
          opacity: 0;
          &:nth-child(2),
          &:nth-child(3),
          &:nth-child(4) {
            background-image: -webkit-linear-gradient(
              left,
              rgba(250, 5, 60, 0.4),
              rgba(110, 100, 120, 0.4)
            );
          }
          div {
            text-align: center;
          }
          div:nth-child(n) {
            height: 100%;
          }
          div:nth-child(1) {
            width: 5%;
            font-style: italic;
            font-size: 1.65vw;
          }
          div:nth-child(2) {
            width: 30%;
            white-space: nowrap; /* 保证文本在一行内显示 */
            overflow: hidden; /* 超出容器部分隐藏 */
            text-overflow: ellipsis; /* 超出部分显示省略号 */
            text-align: left; /* 文本对齐方式 */
            display: inline-block;
            img {
              width: 5.5%;
              vertical-align: middle;
              margin-right: 2.5%;
            }
          }
          div:nth-child(3) {
            width: 5%;
            img {
              vertical-align: middle;
            }
          }
        }
        .list_show {
          transform: translate(0, 0);
          opacity: 1;
        }
        .wx_list_item {
          div {
            &:nth-child(4),
            &:nth-child(5),
            &:nth-child(6),
            &:nth-child(7) {
              width: 15%;
            }
          }
        }
        .wb_list_item {
          div {
            &:nth-child(4),
            &:nth-child(5),
            &:nth-child(6),
            &:nth-child(7),
            &:nth-child(8) {
              width: 12%;
            }
          }
        }
        @keyframes toRight {
          0% {
            left: -5em;
          }
          100% {
            left: 100%;
          }
        }
        .active {
          opacity: 1;
          transition: all 0.5s;
          -webkit-transition: all 0.5s;
          overflow: hidden;
          position: relative;
          background-image: -webkit-linear-gradient(
            left,
            rgba(0, 200, 255, 1),
            rgba(145, 165, 185, 1)
          );
          &:nth-child(2),
          &:nth-child(3),
          &:nth-child(4) {
            background-image: -webkit-linear-gradient(
              left,
              rgba(250, 5, 60, 1),
              rgba(110, 100, 120, 1)
            );
          }
          &::before {
            position: absolute;
            content: "";
            top: 0;
            left: 0%;
            width: 5em;
            height: 100%;
            background: url("../assets/Starting/img-phb/gt.png") no-repeat
              center center;
            background-size: 100% 100%;
            animation: toRight 3s ease-in-out;
          }
          .counts2 {
            img {
              animation: flipOutX 1s;
            }
          }
        }
      }
    }
  }
}
</style>
